<template>
  <div class="md-layout">
    <div class="md-layout md-layout-item md-size-100">
      <div class="md-layout-item md-size-40">
        <enquiry-follow-ups></enquiry-follow-ups>
        <overdue-bookings></overdue-bookings>
      </div>

      <div class="md-layout-item md-size-30">
        <upcoming-departures></upcoming-departures>
        <new-bookings></new-bookings>
      </div>

      <div class="md-layout-item md-size-30">
        <monthly-stats></monthly-stats>
        <enquiry-conversions></enquiry-conversions>
      </div>
    </div>
  </div>
</template>
<script>
import EnquiryFollowUps from "./Widgets/EnquiryFollowUps.vue";
import UpcomingDepartures from "./Widgets/UpcomingDepartures.vue";
import NewBookings from "./Widgets/NewBookings.vue";
import MonthlyStats from "./Widgets/MonthlyStats.vue";
import EnquiryConversions from "./Widgets/EnquiryConversions.vue";
import OverdueBookings from "./Widgets/OverduePayments.vue";

export default {
  components: {
    EnquiryFollowUps,
    UpcomingDepartures,
    NewBookings,
    MonthlyStats,
    EnquiryConversions,
    OverdueBookings
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";

.dashboard-widget {
  margin-bottom: 2rem;
}
</style>
